import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation modules
import navEn from "./locales/modules/nav/en.json";
import navIt from "./locales/modules/nav/it.json";
import navEs from "./locales/modules/nav/es.json";

import authEn from "./locales/modules/auth/en.json";
import authIt from "./locales/modules/auth/it.json";
import authEs from "./locales/modules/auth/es.json";

import dietEn from "./locales/modules/diet/en.json";
import dietIt from "./locales/modules/diet/it.json";
import dietEs from "./locales/modules/diet/es.json";

import dashboardEn from "./locales/modules/dashboard/en.json";
import dashboardIt from "./locales/modules/dashboard/it.json";
import dashboardEs from "./locales/modules/dashboard/es.json";

import indexEn from "./locales/modules/index/en.json";
import indexIt from "./locales/modules/index/it.json";
import indexEs from "./locales/modules/index/es.json";

import mealsEn from "./locales/modules/meals/en.json";
import mealsIt from "./locales/modules/meals/it.json";
import mealsEs from "./locales/modules/meals/es.json";

import weightEn from "./locales/modules/weight/en.json";
import weightIt from "./locales/modules/weight/it.json";
import weightEs from "./locales/modules/weight/es.json";

import chartsEn from "./locales/modules/charts/en.json";
import chartsIt from "./locales/modules/charts/it.json";
import chartsEs from "./locales/modules/charts/es.json";

import profileEn from "./locales/modules/profile/en.json";
import profileIt from "./locales/modules/profile/it.json";
import profileEs from "./locales/modules/profile/es.json";

const resources = {
    en: {
        translation: {
            ...navEn,
            ...authEn,
            ...dietEn,
            ...dashboardEn,
            ...indexEn,
            ...mealsEn,
            ...weightEn,
            ...chartsEn,
            ...profileEn,
        },
    },
    it: {
        translation: {
            ...navIt,
            ...authIt,
            ...dietIt,
            ...dashboardIt,
            ...indexIt,
            ...mealsIt,
            ...weightIt,
            ...chartsIt,
            ...profileIt,
        },
    },
    es: {
        translation: {
            ...navEs,
            ...authEs,
            ...dietEs,
            ...dashboardEs,
            ...indexEs,
            ...mealsEs,
            ...weightEs,
            ...chartsEs,
            ...profileEs,
        },
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
